import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";
import { BlogsSlider } from "../../Slider/BlogsSlider";
import { API } from "../../api";
import Testimonial from "../../home/Testimonial";
import Offers from "../../products/Offers";
import "../../products/product.css";

const blogs = [
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
];

const ProudPortfolio = () => {
  const pathRef = useRef(null);
  const heroRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Fetch product data from API
  const fetchProductData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/product-portfolio`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch product data");
      }

      const data = await response.json();
      setProductData(data);
    } catch (error) {
      console.error("Error fetching product data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get media URL

  useEffect(() => {
    fetchProductData();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // SVG Path Animation
  useEffect(() => {
    const path = pathRef.current;
    if (!path) return;

    const pathLength = path.getTotalLength();
    path.style.strokeDasharray = pathLength;
    path.style.strokeDashoffset = pathLength;

    const animatePath = () => {
      path.style.transition = "stroke-dashoffset 5s ease-in-out";
      path.style.strokeDashoffset = "0";

      setTimeout(() => {
        path.style.transition = "none";
        path.style.strokeDashoffset = pathLength;

        setTimeout(() => {
          path.style.transition = "stroke-dashoffset 5s ease-in-out";
          path.style.strokeDashoffset = "0";
        }, 100);
      }, 5000);
    };

    const interval = setInterval(animatePath, 7000);
    animatePath();

    return () => clearInterval(interval);
  }, [pathRef.current]);

  // Intersection Observer for hero section
  useEffect(() => {
    if (loading || !heroRef.current) return;

    const heroBg = document.querySelector(".heroBg");
    const herotext = document.querySelector(".heroText");

    if (!heroBg || !herotext) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          heroBg.classList.add("active");
          setTimeout(() => {
            herotext.classList.add("active");
          }, 1000);
        } else {
          herotext.classList.remove("active");
          setTimeout(() => {
            heroBg.classList.remove("active");
          }, 500);
        }
      },
      { rootMargin: "0px", threshold: 0.3 }
    );

    observer.observe(heroRef.current);

    return () => {
      observer.disconnect();
    };
  }, [loading]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error && !productData) {
    return (
      <div className="alert alert-warning m-3" role="alert">
        Error loading product data: {error}
      </div>
    );
  }

  // Safe data access with fallbacks
  const {
    heroSection = {},
    heroBackgroundSection = {},
    offersSection = {},
    investmentChallengeSection = {},
    screeningSection = {},
  } = productData || {};

  const safeHeroSection = {
    mainHeading: {
      text: heroSection.mainHeading?.text || "Proud",
      highlight: heroSection.mainHeading?.highlight || "Portfolio",
    },
    subtitle:
      heroSection.subTitle || "Invest in tomorrow's Multibaggers, TODAY!",
    description:
      heroSection.description ||
      "For those who want to own what they'll be proud of 10 years from now!",
    buttonText: heroSection.button?.text || "Know More",
  };

  const safeHeroBackgroundSection = {
    cards: heroBackgroundSection.cards || [],
    conclusion: {
      highlightedText:
        heroBackgroundSection.conclusion?.highlightedText ||
        "That's what the Proud Portfolio is built to solve.",
      description:
        heroBackgroundSection.conclusion?.description ||
        "A high-conviction, long-term equity strategy focused on identifying scalable, growth oriented businesses that have the potential to create outsized value over time.",
    },
  };

  const safeOffersSection = {
    title: offersSection.title || "Our Offering",
    subtitle: {
      text: offersSection.subtitle?.text || "Investment",
      highlight: offersSection.subtitle?.highlight || "Strategy",
    },
    offers: offersSection.offers || [],
  };

  const safeInvestmentChallengeSection = {
    title: {
      text:
        investmentChallengeSection.title?.text || "Do you get impatient with",
      highlight:
        investmentChallengeSection.title?.highlight || "long-term investments",
    },
    subtitle:
      investmentChallengeSection.subtitle || "during market corrections?",
    description:
      investmentChallengeSection.description ||
      "That's where most investors go wrong—exiting too early",
    strategies: investmentChallengeSection.strategies || [],
    ctaSection: {
      text:
        investmentChallengeSection.ctaSection?.text ||
        "Back the next generation of long-term winners.",
      highlightedText:
        investmentChallengeSection.ctaSection?.highlightedText ||
        "With clarity and conviction.",
      buttonText:
        investmentChallengeSection.ctaSection?.buttonText || "Book a call",
    },
  };

  const safeScreeningSection = {
    title: {
      text: screeningSection.title?.text || "Are you",
      highlight: screeningSection.title?.highlight || "screening for potential",
    },
    subtitle:
      screeningSection.subtitle ||
      "—but unsure how to judge true business quality?",
    frameworkItems: screeningSection.frameworkItems || [],
    descriptionSection: {
      title: screeningSection.descriptionSection?.title || "We do that for ",
      highlight: screeningSection.descriptionSection?.highlight || "you.",
      description:
        screeningSection.descriptionSection?.description ||
        "Our research framework covers over 100 parameters, including:",
      conclusion: {
        text:
          screeningSection.descriptionSection?.conclusion?.text ||
          "This is fixed income done right—",
        highlightedText:
          screeningSection.descriptionSection?.conclusion?.highlightedText ||
          "dynamic, credit-conscious, and yield-focused.",
        description:
          screeningSection.descriptionSection?.conclusion?.description ||
          "Build a smarter fixed income core. Backed by credit rigour and tactical thinking.",
        buttonText:
          screeningSection.descriptionSection?.conclusion?.buttonText ||
          "Know More",
      },
    },
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="row m-0 p-0 pageBg">
        <div className="col-md-6 d-flex align-items-end justify-content-center">
          <div className="col-11 text-start" data-aos="zoom-in-up">
            <p className="fs-1 fw-bold line-height-1 mb-2">
              <span className="org">{safeHeroSection.mainHeading.text}</span>{" "}
              {safeHeroSection.mainHeading.highlight}
            </p>
            <p className="tJustify fw-bold mb-3">{safeHeroSection.subtitle}</p>
            <p className="tJustify fs-5 mb-3">{safeHeroSection.description}</p>

            <button
              className="buttonEffect mb-2"
              onClick={() =>
                navigate(safeHeroSection.button?.link || "/about-us")
              }
            >
              {safeHeroSection.buttonText}
            </button>
          </div>
        </div>
        <div className="col-md-6 d-flex align-items-end justify-content-end">
          <div className="col-md-10 col-12">
            <svg
              id="mySvg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="auto"
              viewBox="0 0 869 832"
              fill="none"
              className="mt-4"
            >
              <path
                ref={pathRef}
                id="myPath"
                d="M35.5 832V627.5H232V427H446.5V233H651.5V35H868.5"
                stroke="#F47024"
                strokeWidth="70"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Hero Background Section */}
      <div className="productHero" ref={heroRef}>
        <div className="heroBg"></div>
        <div className="heroText d-flex align-items-center">
          <div className="col-11">
            <div className="">
              {safeHeroBackgroundSection.cards.map((card, index) => (
                <div
                  key={index}
                  className="border product-padding-card boredr-color-wrapper mt-4"
                >
                  <p className="fs-1">
                    {card.text}
                    <span className="org">{card.highlight}</span>
                  </p>
                </div>
              ))}
            </div>
            <div className="border p-4 mt-4">
              <p className="fs-4 org mb-5 font-italic">
                {safeHeroBackgroundSection.conclusion.highlightedText}
              </p>
              <p className="fs-4">
                {safeHeroBackgroundSection.conclusion.description}
              </p>
            </div>
            <br />
          </div>
        </div>
      </div>

      {/* Offers Section */}
      <div>
        <div className="col-11 m-auto mt-5">
          <p>{safeOffersSection.title}</p>
          <p className="fs-1">
            {safeOffersSection.subtitle.text}{" "}
            <span className="fw-semibold org">
              {safeOffersSection.subtitle.highlight}
            </span>
          </p>
          <div className="offerMobile">
            <div className="row mt-4 h-100">
              {safeOffersSection.offers.map((offer, index) => (
                <div key={index} className="col-lg-4 col-md-6 mt-4">
                  <div className="col-11 m-auto text-start p-3 investCart">
                    <p className="fs-3 fw-semibold">{offer.title}</p>
                    <div className="my-5">
                      <br />
                    </div>
                    {offer.points &&
                      offer.points.map((point, pointIndex) => (
                        <p key={pointIndex} className="fs-5">
                          {point}
                        </p>
                      ))}
                    {offer.buttonName && (
                      <button
                        className="buttonEffect mt-3"
                        onClick={() => navigate("/contact-us")}
                      >
                        {offer.buttonName}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="offerPc">
            <Offers offers={safeOffersSection.offers} />
          </div>
        </div>
      </div>

      {/* Investment Challenge Section */}
      <div className="col-11 m-auto mt-4 mb-5">
        <p className="fs-1 fw-bold" data-aos="fade-up">
          {safeInvestmentChallengeSection.title.text}
          <span className="org">
            {" "}
            {safeInvestmentChallengeSection.title.highlight}{" "}
          </span>
          {safeInvestmentChallengeSection.subtitle}
        </p>
        <p className="fs-4">{safeInvestmentChallengeSection.description}</p>
        <div className="boredr-color-wrapper border border-2 p-5 mt-5">
          <div>
            {safeInvestmentChallengeSection.strategies.map(
              (strategy, index) => (
                <div key={index} className={index > 0 ? "mt-5" : ""}>
                  <p className="fs-4 fw-bold font-italic">
                    <span className="fw-bold">{strategy.boldText}</span>
                    <span className="org">{strategy.highlightedText}</span>
                  </p>
                  <p className="fs-4">{strategy.description}</p>
                </div>
              )
            )}
          </div>
        </div>
        <div className="boredr-color-wrapper border border-2 p-5 mt-5">
          <div>
            <p className="fs-4 fw-bold font-italic">
              {safeInvestmentChallengeSection.ctaSection.text}
            </p>
            <p className="fs-2 fw-bold org">
              {safeInvestmentChallengeSection.ctaSection.highlightedText}
            </p>
          </div>
          <div className="mt-4">
            <button
              className="buttonEffect mb-2"
              onClick={() => navigate("/contact-us")}
            >
              {safeInvestmentChallengeSection.ctaSection.buttonText}
            </button>
          </div>
        </div>
      </div>

      {/* Screening Section */}
      <div className="col-11 m-auto mt-4">
        <p className="fs-1 fw-bold" data-aos="fade-up">
          {safeScreeningSection.title.text}{" "}
          <span className="org">{safeScreeningSection.title.highlight}</span>
          {safeScreeningSection.subtitle}
        </p>

        <div className="row">
          <div className="col-lg-6">
            <div className="col-11 m-auto row">
              {safeScreeningSection.frameworkItems.map((item, index) => (
                <div key={index} className="col-sm-6 mt-4" data-aos="fade-up">
                  <Link
                    activeClass="active"
                    to="points"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="bg-card-box-color p-3 h-full d-flex align-items-center justify-content-center">
                      <div className="my-3 text-center">
                        <p className="fs-4 fw-bold">{item.title}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="text-start points">
              <p className="fs-1 fw-bold mt-3 text-center" data-aos="fade-up">
                {safeScreeningSection.descriptionSection.title}
                <span className="fw-bold org">
                  {safeScreeningSection.descriptionSection.highlight}
                </span>
              </p>
              <p className="fs-5 tJustify text-center" data-aos="fade-up">
                {safeScreeningSection.descriptionSection.description}
              </p>
              <div className="border d-flex flex-column gap-4 p-5 boredr-color-wrapper mt-5">
                <div>
                  <p className="fs-4 text-center">
                    {safeScreeningSection.descriptionSection.conclusion.text}
                  </p>
                  <p className="fs-4 text-center fst-italic">
                    {
                      safeScreeningSection.descriptionSection.conclusion
                        .highlightedText
                    }
                  </p>
                </div>
                <p className="fs-4 text-center">
                  {
                    safeScreeningSection.descriptionSection.conclusion
                      .description
                  }
                </p>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    className="buttonEffect"
                    data-aos="fade-up"
                    onClick={() => navigate("/about-us")}
                  >
                    {
                      safeScreeningSection.descriptionSection.conclusion
                        .buttonText
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Testimonial />

      {/* Blogs Section */}
      <div className="mt-4">
        <div className="col-11 m-auto text-start ">
          <p className="fs-5" data-aos="fade-up">
            Updates
          </p>
          <p className="fs-1 fw-semibold" data-aos="fade-up">
            The latest from{" "}
          </p>
          <p className="fs-1 fw-bold org line-height-1 mb-2" data-aos="fade-up">
            Ladderup
          </p>
          <div className="d-flex gap-3" data-aos="fade-up"></div>
        </div>
        <div data-aos="fade-up">
          <BlogsSlider data={blogs} />
        </div>
      </div>
    </div>
  );
};

export default ProudPortfolio;
